import DateTimePicker from "react-datetime-picker"
import "react-datetime-picker/dist/DateTimePicker.css"
import "react-calendar/dist/Calendar.css"
import "react-clock/dist/Clock.css"
import { format } from "date-fns"
import { ComponentProps } from "react"

type Props = {
  value?: string
  onValueChange: (value: string) => void
} & ComponentProps<typeof DateTimePicker>

export function DateField({ onValueChange, ...props }: Props) {
  return (
    <DateTimePicker
      format="dd / MM / y"
      disableClock
      locale="en-AU"
      onChange={(value) => {
        onValueChange(value ? format(value, "yyyy/MM/dd") : "")
      }}
      {...props}
      value={props.value ?? ""}
      clearIcon={null}
    />
  )
}
